$(() => {
  $('input:not([data-submit-on-enter])').keydown(function (e) {
    return e.which !== 13 && e.keyCode !== 13;
  });
});
